import React from 'react';
import { portal, Portal } from '../../Configs/general';

import ConstructorsInvoiceHistoryGDC from './ConstructorsInvoiceHistory.GDC';

const ConstructorsInvoiceHistory = props => {
  switch (portal) {
    case Portal.Gascaribe:
      return <ConstructorsInvoiceHistoryGDC {...props} />;
    default:
      return <></>;
  }
};

export default ConstructorsInvoiceHistory;
